import * as tslib_1 from "tslib";
import { Utils } from 'cc-common';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
import { Type } from 'class-transformer';
const ɵ0 = () => UserNameDisplayResultDto, ɵ1 = () => Date;
export class WorkflowHistoryResultDto {
    get userNameDisplayText() {
        return Utils.notNullAndDefined(this.user) ? this.user.displayName : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], WorkflowHistoryResultDto.prototype, "user", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], WorkflowHistoryResultDto.prototype, "actionedOn", void 0);
export { ɵ0, ɵ1 };
